import * as React from "react"
import {NavLink} from "../navLink";
import {NavDropdown} from "../navDropdown";

export const StarterNavigation = () => {

    return (
        <>
            <NavLink title="導入の手引きトップ" link="/starter"/>
            <div className="mt-4">
                <NavDropdown name="キャムマックス概要"  items={[
                    {title: "キャムマックスとは？", link: "/starter/cammacs/"},
                    {title: "ご利用方法・ご利用環境", link: "/starter/how-to-use/"},
                    {title: "トライアルの流れ", link: "/starter/first/trial-flow/"},
                    {title: "トライアル中のよくあるご質問", link: "/starter/first/trial-faq/"},
                    {title: "ご契約後から本番稼働までの流れ", link: "/starter/first/support/"}
                ]}/>
                <NavDropdown name="初期設定" items={[
                    {title: "初期設定", link: "/starter/init/init-procedure/"},
                    {title: "初回ログイン", link: "/starter/init/first-login/"}
                ]}/>
                <NavDropdown name="EC連携設定"  items={[
                    {title: "EC初期設定", link: "/starter/ec-setting/ec"},
                    {title: "MakeShop連携設定", link: "/starter/ec-setting/makeshop/"},
                    {title: "カラーミー連携設定", link: "/starter/ec-setting/color-me/"},
                    {title: "ショップサーブ連携設定", link: "/starter/ec-setting/shopserve/"},
                    {title: "Bカート連携設定", link: "/starter/ec-setting/bcart/"},
                    {title: "ECモール連携設定", link: "/starter/ec-setting/mall/"}
                ]}/>
                <NavDropdown name="POS連携設定" items={[
                    {title: "スマレジ連携設定", link: "/starter/pos-setting/sumaregi/"},
                    {title: "square連携設定", link: "/starter/pos-setting/square/"},
                ]}
                />
                <NavDropdown name="操作のヒント" items={[
                    {title: "日付の入力補助", link: "/starter/operation/date/"},
                    {title: "入力項目の幅を変更する", link: "/starter/operation/input-width/"},
                    {title: "マスタデータの入力補助", link: "/starter/operation/picker/"},
                    {title: "商品の複数入力", link: "/starter/operation/multiple-products/"},
                    {title: "テーマを変更する", link: "/starter/operation/theme/"},
                ]}
                />
            </div>
        </>
    )
}
